<template>
    <div v-if="showModal" id="center_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">정산</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="field">
                        <label class="ui left aligned header">센터 및 기사</label>
                        <select class="ui simple dropdown" v-model="filter._id">
                            <option v-for="center in getCenters()" :key="center._id" :value="center._id">{{ center.name }}</option>
                            <option v-for="worker in getWorkers()" :key="worker._id" :value="worker._id">{{ worker.name }}</option>
                        </select>
                    </div>
                    <div class="two fields">
                        <div class="field">
                            <div class="ui calendar" id="calendar_start">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="완료날짜(부터)">
                                </div>
                            </div>
                        </div>
                        <div class="field">
                            <div class="ui calendar" id="calendar_end">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="완료날짜(까지)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui form">
                    <div class="inline field">
                        <input type="password" name="password" placeholder="비밀번호 입력" v-model="password">
                        <div class="ui primary button" @click="download">다운로드</div>
                        <div class="ui button" @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, filter: 0, centerIds: 0, password: 0, }
    },
    created: function() {
        this.showModal = false;
        this.filter = 0;
    },
    mounted: function() {
        this.$event.set("centerCalculate_open", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("centerCalculate_open");
    },
    methods: {
        open() {
            this.showModal = true;
            this.filter = {};
            this.filter._id = this.centers[0]._id;
            this.filter.month = new Date().getMonth();
            this.centerIds = [];
            this.password = "";
            this.centers.map((c, i) => this.centerIds.push(c._id));
            this.$nextTick(() => {
                this.$ui.calendar_StartEnd("#calendar_start", "#calendar_end",
                    (date, text) => { this.filter.dateStart = text; },
                    (date, text) => { this.filter.dateEnd = text; });
            });
        },
        close() {
            this.showModal = false;
        },
        download() {
            if (this.password != this.ownerPassword) {
                alert("비밀번호가 맞지 않습니다!");
                return;
            }

            if (this.filter.dateStart && this.filter.dateEnd) {
                if (this.centerIds.includes(this.filter._id)) {
                    this.$event.call("openLoading");
                    this.$api.calculateCenter(this.filter._id, this.filter.dateStart, this.filter.dateEnd, (resData) => {
                        this.$event.call("closeLoading");
                        if (resData.error) {
                            alert(resData.error.message);
                        } else {
                            this.$excel.downloadCalculate(this, resData.items, resData.title);
                        }
                    });
                } else {
                    this.$event.call("openLoading");
                    this.$api.calculateWorker(this.filter._id, this.filter.dateStart, this.filter.dateEnd, (resData) => {
                        this.$event.call("closeLoading");
                        if (resData.error) {
                            alert(resData.error.message);
                        } else {
                            this.$excel.downloadCalculate(this, resData.items, resData.title);
                        }
                    });
                }
            }
        },
        getCenter(_centerId) {
            for (const center of this.centers) {
                if (center._id == _centerId) {
                    return center;
                }
            }
            return "";
        },
        getWorkers() {
            const array = [];
            for (const worker of this.workers) {
                const center = this.getCenter(worker._center);
                if (center.name == "가온본사" && worker.position == "배송기사") {
                    array.push(worker);
                }
            }
            return array;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        ownerPassword: function() { return this.$store.getters.ownerPassword; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        constantNames: function() { return this.$store.getters.constantNames; },
    },
}
</script>

<style>

#center_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#center_modal .column {
    max-width: 600px;
}

#center_modal #header {
    padding: 20px 30px;
}

#center_modal #body {
    padding: 0;
}

#center_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#center_modal #footer .ui.form {
    padding: 0;
}

#center_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/CenterModal_Calculate.vue